/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var PageableCollection = require('psa-backbone/models/PageableCollection');

var PlaceholderView = require('common/views/PlaceholderView');

var DepSubFundAuditSectionView = require('../views/DepSubFundAuditSectionView');
var GetTrustAuditsByTrustSubFund = require('../services/GetTrustAuditsByTrustSubFund');

module.exports = {
  channel: 'dp',

  event: 'build:sub-fund-audit-view',

  builder: function(fundId, isTrust) {
    return new PlaceholderView({
      viewPromise: buildEntityFundView(fundId, isTrust)
    });
  }
};

function buildEntityFundView(fundId, isTrust) {
  var deferred = $.Deferred();

  GetTrustAuditsByTrustSubFund(fundId)
    .done(function(audits) {
      deferred.resolve(
        new DepSubFundAuditSectionView({
          collection: new PageableCollection(audits, { pageSize: 25 }),
          isTrust: isTrust
        })
      );
    })
    .fail(function(err) {
      deferred.reject(err);
    });
  return deferred.promise();
}
